import { render, staticRenderFns } from "./TemplateActions.vue?vue&type=template&id=327662ed&scoped=true"
import script from "./TemplateActions.vue?vue&type=script&lang=js"
export * from "./TemplateActions.vue?vue&type=script&lang=js"
import style0 from "./TemplateActions.vue?vue&type=style&index=0&id=327662ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327662ed",
  null
  
)

export default component.exports